<h2 class="page-title">Test Direct Hit Implementation</h2>

<div class="card-section">
  <div class="mb-3">
    <label class="form-label">Paste page source here:</label>
    <textarea [(ngModel)]="page_source" class="form-control" rows="5"
      placeholder="Paste page source here" style="resize: none;"></textarea>
  </div>

  <div class="d-flex align-items-center gap-3 mb-3">
    <button class="btn btn-primary" (click)="extractData()">Extract</button>
    <span class="status-text">Status: {{ status }}</span>
  </div>

  @if (response) {
    <p class="mb-3 status-text">Classification: <strong>{{ response?.classification }}</strong></p>
  }

  <table class="data-table">
    <thead>
      <tr>
        <th style="width: 30%;">Attribute</th>
        <th>Extracted Value</th>
        <th style="width: 20%;">Source</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Brand / Manufacturer</td>
        <td>@if (response) { <span>{{ response['oem_info']['brand'] }}</span> }</td>
        <td class="text-muted small">{{ source('oem_info.brand') }}</td>
      </tr>
      <tr>
        <td>Manufacturer Part Number</td>
        <td>@if (response) { <span>{{ response['oem_info']['number'] }}</span> }</td>
        <td class="text-muted small">{{ source('oem_info.number') }}</td>
      </tr>
      <tr>
        <td>GTIN / EAN</td>
        <td>@if (response) { <span>{{ response['oem_info']['gtin'] }}</span> }</td>
        <td class="text-muted small">{{ source('oem_info.gtin') }}</td>
      </tr>
      <tr>
        <td>Name / Title</td>
        <td>@if (response) { <span>{{ response['internal_info']['name'] }}</span> }</td>
        <td class="text-muted small">{{ source('internal_info.name') }}</td>
      </tr>
      <tr>
        <td>Supplier Internal Number</td>
        <td>@if (response) { <span>{{ response['internal_info']['number'] }}</span> }</td>
        <td class="text-muted small">{{ source('internal_info.number') }}</td>
      </tr>
      <tr>
        <td>Description</td>
        <td>@if (response) { <span>{{ response['internal_info']['description'] }}</span> }</td>
        <td class="text-muted small">{{ source('internal_info.description') }}</td>
      </tr>
      <tr>
        <td>Product Group</td>
        <td>@if (response) { <span>{{ response['internal_info']['group'] }}</span> }</td>
        <td class="text-muted small">{{ source('internal_info.group') }}</td>
      </tr>
      <tr>
        <td>Amount</td>
        <td>@if (response) { <span>{{ response['prices'][0]['amount_text'] }}</span> }</td>
        <td class="text-muted small">{{ source('prices.amount') }}</td>
      </tr>
      <tr>
        <td>Price</td>
        <td>@if (response) {
          <span>{{ priceLabel(response['prices'][0]['price']) }}</span>
          @if (response['prices'][0]['price_text']) {
            <span class="text-muted"> ({{ response['prices'][0]['price_text'] }})</span>
          }
        }</td>
        <td class="text-muted small">{{ source('prices.price') }}</td>
      </tr>
      <tr>
        <td>Price status step</td>
        <td class="text-muted small">a status it finds is shown as the price</td>
        <td class="text-muted small">{{ source('price_status') }}</td>
      </tr>
      <tr>
        <td>Currency</td>
        <td>@if (response) {
          <span>{{ response['prices'][0]['currency'] ?? 'unknown' }}</span>
          @if (response['prices'][0]['currency_text']) {
            <span class="text-muted"> ({{ response['prices'][0]['currency_text'] }})</span>
          }
        }</td>
        <td class="text-muted small">{{ source('prices.currency_text') }}</td>
      </tr>
      <tr>
        <td>VAT</td>
        <td>@if (response) {
          <span>{{ response['prices'][0]['vat_included'] === true ? 'included' : response['prices'][0]['vat_included'] === false ? 'excluded' : 'unknown' }}</span>
          @if (response['prices'][0]['vat_source']) {
            <span class="text-muted"> [{{ response['prices'][0]['vat_source'] === 'supplier_default' ? 'supplier default' : response['prices'][0]['vat_source'] }}]</span>
          }
          @if (response['prices'][0]['vat_text']) {
            <span class="text-muted"> ({{ response['prices'][0]['vat_text'] }})</span>
          }
        }</td>
        <td class="text-muted small">{{ source('prices.vat_text') }}</td>
      </tr>
      <tr>
        <td>Delivery</td>
        <td>@if (response) { <span>{{ response['prices'][0]['delivery_text'] }}</span> }</td>
        <td class="text-muted small">{{ source('prices.delivery_text') }}</td>
      </tr>
      <tr>
        <td>Condition</td>
        <td>@if (response) { <span>{{ response['condition']['condition_text'] }}</span> }</td>
        <td class="text-muted small">{{ source('condition') }}</td>
      </tr>
    </tbody>
  </table>
</div>
